module.exports = __webpack_public_path__ + "img/Diners-club.ee4db064.svg";